import React, { useEffect, useState } from "react";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import ConfiguratorRoot from "../../examples/Configurator/ConfiguratorRoot";
import PropTypes from "prop-types";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import useApi from "../../components/Utils/api";
import toast from "utils/toast";
import MenuItem from "@mui/material/MenuItem";
import {FormControl, InputLabel, Select, InputAdornment} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import {generatePassword} from "../../utils/generatePassword";
import Refresh from "@mui/icons-material/Refresh";
import HistoryIcon from '@mui/icons-material/History';



function UpdateUser({user, openConfigurator, setOpenConfigurator}) {
  const [updatedUser, setUpdatedUser] = useState(user);
  const [showPassword, setShowPassword] = useState(false);
  const api = useApi();

  useEffect(() => {
    setUpdatedUser(user)
  },[user])
  const updateUserFormHandler = (form) => {
    form.preventDefault();
    let updateUserReq = updatedUser;
    delete updateUserReq.authorities;
    if(user.passwd === updatedUser.passwd) {
      updateUserReq.passwd = '';
    }
    api.post("/users/update", updateUserReq)
      .then((response) => {
        if(response.data.statusCodeValue === 200){
          toast.success("User successfully updated.");
          setOpenConfigurator(false);
        }
      })
      .catch(() => {
        console.log(error.response);
      })
    console.log(updateUserReq);
  }
  return (
    <ConfiguratorRoot variant="permanent" ownerState={{ openConfigurator }} configuratorwidth={500}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={4}
        pb={0.5}
        px={3}
      >
        <MDBox>
          <MDTypography variant="h5">Update User</MDTypography>
          <MDTypography variant="body2" color="text">
            {user?.userId}
          </MDTypography>
        </MDBox>

        <Icon
          sx={({ typography: { size }, palette: { dark, white } }) => ({
            fontSize: `${size.lg} !important`,
            color: dark.main,
            stroke: "currentColor",
            strokeWidth: "2px",
            cursor: "pointer",
            transform: "translateY(5px)",
          })}
          onClick={() => setOpenConfigurator(false)}
        >
          close
        </Icon>
      </MDBox>
      <Divider />
      <MDBox component="form" role="form" onSubmit={(form) => updateUserFormHandler(form)} style={{maxWidth: '480px'}}>
        <MDBox
          display="flex"
          justifyContent="space-between"
          mb={2}
        >
          <MDBox flex={1} boxSizing={'border-box'} mr={1}>
            <MDInput type="text" label="Username" name="userId" onChange={(e) => setUpdatedUser({ ...updatedUser, userId: e.target.value })} value={updatedUser?.userId} focused fullWidth disabled />
          </MDBox>
          {/* <MDBox flex={1} boxSizing={'border-box'} mr={1}>
            <MDInput type="text" label="Status" name="status" onChange={(e) => setUpdatedUser({ ...updatedUser, userId: e.target.value })} value={updatedUser?.status === "0" ? 'Inactive' : updatedUser?.status === "1" ? 'Active' : updatedUser?.status === "3" ? 'Block' : updatedUser?.status === "7" ? 'New User' : ''} focused fullWidth disabled />
          </MDBox> */}
        </MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          mb={2}
        >
          <MDBox flex={1} boxSizing={'border-box'} mr={1}>
            <MDInput type="text" label="First Name" name="first_name" onChange={(e) => setUpdatedUser({ ...updatedUser, firstName: e.target.value })} value={updatedUser?.firstName} focused fullWidth required />
          </MDBox>
          <MDBox flex={1} boxSizing={'border-box'}>
            <MDInput type="text" label="Last Name" name="last_name" onChange={(e) => setUpdatedUser({ ...updatedUser, lastName: e.target.value })} value={updatedUser?.lastName} focused fullWidth required />
          </MDBox>
        </MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          mb={2}
        >
          <MDBox flex={4} boxSizing={'border-box'} mr={1}>
            <MDInput type="email" label="Email" name="email" onChange={(e) => setUpdatedUser({ ...updatedUser, emailId: e.target.value })} value={updatedUser?.emailId} focused fullWidth required />
          </MDBox>
          <MDBox flex={1} boxSizing={'border-box'}>
            <FormControl fullWidth style={{ height: '100%' }}>
              <InputLabel id="label-role">Select User Role</InputLabel>
              <Select
                  labelId="label-role"
                  id="label-role"
                  label="Select User Role"
                  fullWidth
                  style={{ height: '100%' }}
                  name="role"
                  onChange={(e) => setUpdatedUser({ ...updatedUser, role: e.target.value })}
                  value={updatedUser?.role}
                  disabled
              >
                <MenuItem value="">-Select user level-</MenuItem>
                <MenuItem value="MAKER">Admin</MenuItem>
                <MenuItem value="G_MAKER">Guest/Viewer</MenuItem>
              </Select>
            </FormControl>
            {/*<MDInput type="text" label="Role" name="role" value={user.role === "ADMIN" ? 'MAKER' : user.role === "SUPERADMIN" ? 'ADMIN' : ''} fullWidth disabled />*/}
          </MDBox>
        </MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          mb={2}
        >
          <MDBox flex={1} boxSizing={'border-box'} mr={1}>
            <MDInput type="tel" label="Mobile No" name="mobileNo" onChange={(e) => setUpdatedUser({ ...updatedUser, mobileNo: e.target.value })} value={updatedUser?.mobileNo} fullWidth focused disabled />
          </MDBox>
          <MDBox flex={1} boxSizing={'border-box'}>
            <MDInput type="text" label="Department" name="dept" onChange={(e) => setUpdatedUser({ ...updatedUser, dept: e.target.value })} value={updatedUser?.dept} fullWidth focused required />
          </MDBox>
        </MDBox>
        <MDBox mb={2}>
          <MDInput 
            type={showPassword ? 'text' : 'password'}
            label="Password" 
            name="passwd" 
            onChange={(e) => setUpdatedUser({ ...updatedUser, passwd: e.target.value })} 
            fullWidth 
            value={updatedUser?.passwd || ''}
            focused={updatedUser?.passwd ? true : undefined}
            InputLabelProps={{
              shrink: updatedUser?.passwd ? true : undefined
            }}
            InputProps={{
                endAdornment: (
                    <>
                        {/* Button to toggle password visibility */}
                        <InputAdornment position="end">
                            <Tooltip title={showPassword ? 'Hide Password' : 'Show Password'}>
                                <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>

                        {/* Button to generate password */}
                        <InputAdornment position="end">
                            <Tooltip title="Generate Password">
                                <IconButton onClick={() => {
                                  let password = generatePassword(12, true);
                                  setUpdatedUser({ ...updatedUser, passwd: password });
                                }}>
                                    <Refresh />
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    </>
                ),
            }}
          />
        </MDBox>

        <MDBox mt={4} mb={1}>
          <MDButton type="submit" variant="gradient" color="info" style={{float : 'right'}}>
            update
          </MDButton>
        </MDBox>
      </MDBox>
    </ConfiguratorRoot>
  );
}

UpdateUser.defaultProps = {
  user: [],
  openConfigurator: false,
  setOpenConfigurator: false
}

UpdateUser.propTypes = {
  user: PropTypes.object,
  openConfigurator: PropTypes.bool,
  setOpenConfigurator: PropTypes.func
}

export default UpdateUser;